import { EVENT_CATEGORIES, EVENT_NAMES, HIT_TYPE } from '../../../beacon/const';

export const pairingRemovedSecondaryBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.PAIR,
  eventName: EVENT_NAMES.PAIRING_REMOVED_SECONDARY,
});
